// you can import modules from the theme lib or even from
// NPM packages if they support it…
import CookieManager from "./components/CookieManager";
import ExampleComponent1 from "./components/ExampleComponent1";
import HeaderOnScroll from "./components/HeaderOnScroll";
import HeaderOnMobile from "./components/HeaderOnMobile";

// const ExampleModule2 = require('./components/example-2');

import AOS from "aos";
import LazyLoad from "vanilla-lazyload";
import "alpinejs";

window.addEventListener("DOMContentLoaded", (event) => {
  if (CookieManager.getCookie("vnx_qwerty") != "1") {
    setTimeout(() => {
      CookieManager.setCookie("vnx_qwerty", "1", { "max-age": 7 * 24 * 60 * 60 });

      HeaderOnScroll.init();
      HeaderOnMobile.init();
      ExampleComponent1.init();
      new LazyLoad();

      AOS.init({
        anchorPlacement: "top-top",
        duration: 650,
        once: true,
      });
    }, 2000);
  } else {
    HeaderOnScroll.init();
    HeaderOnMobile.init();
    ExampleComponent1.init();
    new LazyLoad();

    AOS.init({
      duration: 500,
      once: true,
    });
  }
});

/*-------------------------------------
	On Load
-------------------------------------*/
// jQuery(window).on("load", function() {
// AOS.init({
//   anchorPlacement: "top-top",
//   duration: 650,
//   once: true,
// });
// ExampleComponent1.init();
// HeaderOnScroll.init();
// HeaderOnMobile.init();
// new LazyLoad();
// });
